import React from "react";

function Blog({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4 3.143H3a1 1 0 00-1 1v14l1.5 3 1.5-3v-14a1 1 0 00-1-1z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21 12.144v-4c0-2.358 0-3.536-.732-4.269-.733-.732-1.911-.732-4.268-.732h-3c-2.357 0-3.536 0-4.268.732C8 4.608 8 5.786 8 8.144v8.001c0 2.357 0 3.536.732 4.268.62.62 1.561.716 3.268.73M12 7.143h5M12 11.143h5"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14 19.143s1.5.5 2.5 2c0 0 1.5-4 5.5-6M2 7.143h3"
      ></path>
    </svg>
  );
}

export default Blog;
